import { Directive, HostListener, ElementRef } from '@angular/core';

@Directive({
  selector: '[appExcludePipeCharacter]'
})
export class ExcludePipeCharacterDirective {
  inputElement: HTMLElement;
  containPipeRegex: RegExp = /[|]/g;

  constructor(public el: ElementRef) {
    this.inputElement = el.nativeElement;
  }

  @HostListener('keypress', ['$event'])
  onKeyPress(event: KeyboardEvent): boolean {
    return !new RegExp(this.containPipeRegex).test(event.key);
  }

  @HostListener('paste', ['$event'])
  onPaste(event: ClipboardEvent): void {
    try {
      event.preventDefault();
      this.inputElement.focus();

      const isIE: boolean = !event.clipboardData;
      const clipboardData: any = isIE ? window['clipboardData'].getData('Text') : event.clipboardData.getData('text/plain');
      const pastedInput: string = clipboardData.replace(this.containPipeRegex, '');

      if (isIE) {
        document.execCommand('paste', false, pastedInput);
      } else {
        document.execCommand('insertText', false, pastedInput);
      }
    } catch (_) {}
  }
}
